import { render, staticRenderFns } from "./ActivityDetailPage.vue?vue&type=template&id=5f6c4c1a&"
import script from "./ActivityDetailPage.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetailPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports